// StatCard — the KPI tile from the design: a toned icon tile with an optional
// trailing delta on the first row, then the value (with an optional unit suffix)
// and the metric label. Presentational; the caller formats the value, and passes
// an em-dash when a figure has no data behind it.

import type { ReactNode } from 'react';
import Icon from './Icon';

export type StatCardTone = 'brand' | 'success' | 'warning' | 'info' | 'neutral';

export interface StatCardDelta {
  /** Already-formatted text, e.g. '+2' or '92%'. */
  text: string;
  icon: string;
  tone: 'success' | 'danger' | 'neutral';
}

export interface StatCardProps {
  icon: string;
  tone?: StatCardTone;
  value: ReactNode;
  /** Muted suffix beside the value, e.g. 'this month' / 'open'. */
  unit?: string;
  label: string;
  /** Period-over-period change. Omitted renders nothing in that slot. */
  delta?: StatCardDelta;
}

const StatCard = ({ icon, tone = 'neutral', value, unit, label, delta }: StatCardProps) => (
  <div className='stat-card'>
    <div className='stat-card__top'>
      <span className={`stat-card__tile stat-card__tile--${tone}`}>
        <Icon name={icon} size={20} />
      </span>
      {delta && (
        <span className={`stat-card__delta stat-card__delta--${delta.tone}`}>
          <Icon name={delta.icon} size={16} />
          {delta.text}
        </span>
      )}
    </div>
    <p className='stat-card__value'>
      {value}
      {unit && <span className='stat-card__unit'>{unit}</span>}
    </p>
    <p className='stat-card__label'>{label}</p>
  </div>
);

export default StatCard;
